/**
 * Script relative to supplier show template
 */

import utils from '../misc/utils';

const loadGoogleMapsApi = require('load-google-maps-api');
const loadMoreButton = document.querySelector('[data-role="load-more"]');
const showSupplierNumberButton = document.querySelector('.show-number-button');
const supplierPhoneNumber = document.querySelector('.block-phone-supplier');
const supplierPhoneNumberText = document.querySelector('.grid-supplier__button--contact--text');

if (supplierPhoneNumber && showSupplierNumberButton && supplierPhoneNumberText) {
  supplierPhoneNumber.hidden = true;
  supplierPhoneNumberText.style.display = 'none';

  showSupplierNumberButton.addEventListener('click', () => {
    supplierPhoneNumber.hidden = false;
    showSupplierNumberButton.hidden = true;
    supplierPhoneNumberText.style.display = 'flex';
  });
}

if (loadMoreButton) {
  loadMoreButton.addEventListener('click', function () {
    let divMoreSuppliers = document.querySelectorAll('[data-role="suppliers"]');
    divMoreSuppliers[0].classList.remove('d-none');
    divMoreSuppliers[0].removeAttribute('data-role');

    if (divMoreSuppliers.length === 1) {
      this.setAttribute('disabled', 'disabled');
      this.removeEventListener('click');
    }
  });
}

const mapsValues = document.querySelector('#maps-values');

if (mapsValues) {
  let map,
    currentDayName = utils.isCurrentDayName(), // current day (as a string)
    apiKey = mapsValues.dataset.apiKey,
    mapScriptOptions = {
      'key': apiKey,
    },
    lat = parseFloat(mapsValues.dataset.supplierLat),
    lng = parseFloat(mapsValues.dataset.supplierLng),
    pinIcon = mapsValues.dataset.pinIcon;

// Highlight supplier opening time for current day
  document.querySelector(`[data-day="${currentDayName}"]`).classList.add('ff-wotfard-m');

// Lance l'init de la map
  loadGoogleMapsApi(mapScriptOptions)
    .then(googleMaps => {
      initMap(googleMaps);
    });

// Initialise la map centrée sur le distributeur, avec un marqueur
  function initMap(googleMaps) {
    map = new googleMaps.Map(document.getElementById('map'), {
      center: { lat: lat, lng: lng },
      zoom: 14,
    });

    new googleMaps.Marker({
      position: { lat: lat, lng: lng },
      map: map,
      icon: pinIcon,
    });
  }
}
